module.exports = __webpack_public_path__ + "img/pr-3.7841a63f.png";